import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  if (user && user !== false && user !== null) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    setErr("");
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { 
      toast.success("Welcome back"); 
      nav("/dashboard"); 
    } else { 
      setErr(r.error || "Unable to sign in."); 
    }
  };

  return (
   <div className="min-h-screen grid md:grid-cols-2 grain-bg Digitalis-Login-Wrapper">
  {/* Left — brand panel */}
  <div className="hidden md:flex flex-col justify-between p-10 border-r border-border relative overflow-hidden Digitalis-Brand-Panel">
    <div className="flex items-center gap-3">
      <div>
        <img 
          src="https://digitalis.co.in/wp-content/uploads/2026/05/digitalis-1-scaled.png" 
          alt="Digitalis Logo" 
          className="Digitalis-Logo mb-1"
        />
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          Client CRM Console
        </div>
      </div>
    </div>

        <div className="max-w-md">
          <h1 className="text-5xl lg:text-6xl leading-none font-black">
            The operating system for your service business.
          </h1>
          <p className="mt-6 text-base text-muted-foreground leading-relaxed">
            One place for clients, quotes, projects, deliverables, tasks and payments — so nothing falls through the cracks.
          </p>
          <div className="mt-8 flex flex-wrap gap-2 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
            <span className="px-2 py-1 border border-border rounded">Clients</span>
            <span className="px-2 py-1 border border-border rounded">Projects</span>
            <span className="px-2 py-1 border border-border rounded">Tasks</span>
            <span className="px-2 py-1 border border-border rounded">Deliverables</span>
            <span className="px-2 py-1 border border-border rounded">Finance</span>
          </div>
        </div>

        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          © Digitalis CRM · Made with Love in Bharat
        </div>
      </div>

      {/* Right — form */}
      <div className="flex items-center justify-center p-6 md:p-10 relative">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-5 relative z-10" data-testid="login-form">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-2">Sign in</div>
            <h2 className="text-3xl font-black tracking-tight">Welcome back.</h2>
            <p className="text-sm text-muted-foreground mt-1">Use your team account to continue.</p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="email" className="font-mono text-[10px] uppercase tracking-widest">Email</Label>
            <Input
              id="email"
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.in"
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="font-mono text-[10px] uppercase tracking-widest">Password</Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {err && <div className="text-sm text-destructive" data-testid="login-error">{err}</div>}

          <Button
            type="submit"
            data-testid="login-submit-btn"
            disabled={loading}
            className="w-full h-10 bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
          >
            {loading ? "Signing in…" : "Sign in →"}
          </Button>

          <div className="text-xs text-muted-foreground border-t border-border pt-4">
            <div className="font-mono uppercase tracking-widest mb-1">Credential Demo</div>
            <div className="mt-1">Credential Styling <span className="font-mono">priya.sharma@digitalis.co.in</span> · <span className="font-mono">Password@123</span></div>
            <div className="mt-3 pt-3 border-t border-border">
              Need an account? <Link to="/signup" className="text-primary hover:underline" data-testid="login-signup-link">Request team access →</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
